import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../shared/components/feedback/loading/Loading";
import { useSnackbar } from "../../../shared/components/layout/SnackbarContext";
import { useQuery } from "../../../shared/utils/use_query";
import { IdentityProviderClientContext } from "../../../shared/services/api/contexts";

/*
  This page is used as the Pro Santé Connect OAuth2 callback page.
  It is called by Pro Santé Connect after the user has logged in.
*/

export default function PSCLoginPage() {
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const query = useQuery();
  const identityProviderClient = useContext(IdentityProviderClientContext);

  useEffect(() => {
    const submitPscCode = async (state: string, code: string) => {
      let result;
      try {
        result = await identityProviderClient.submitPSCCallback(code, state);
      } catch (e: any) {
        showSnackbar({ text: e.message, color: "danger" });
      }

      if (result.task === "create") {
        localStorage.setItem("psc-id-token", result.id_token);
        navigate("/auth/signin");
      } else if (result.task === "login") {
        await identityProviderClient.loginWithPSC(result.id_token, result.email);
        navigate("/");
      }
    };

    // the use of the use effect is to make sure that the function is called once
    const code = query.get("code");
    if (!code) {
      showSnackbar({ text: "No code provided", color: "danger" });
      return;
    }
    submitPscCode("", code);
  }, [query, identityProviderClient, navigate, showSnackbar]);

  return (
    <div className="column pt-6 mt-6">
      <Loading message={"Connecting using Pro Santé Connect..."} />
    </div>
  );
}
